import React, { useState } from 'react';
import PortalLayout from './PortalLayout';
import EInvoiceList from './EInvoiceList';

export default function PortalInvoices() {
  const [refreshKey, setRefreshKey] = useState(0);

  React.useEffect(() => {
    const handlePropertyChange = () => setRefreshKey(k => k + 1);
    window.addEventListener('property-changed', handlePropertyChange);
    return () => window.removeEventListener('property-changed', handlePropertyChange);
  }, []);

  return (
    <PortalLayout>
      <div className="p-6" data-testid="portal-invoices">
        <EInvoiceList key={refreshKey} />
      </div>
    </PortalLayout>
  );
}
